
    import Vue from 'vue';
    import AsModal from '@/components/Ui/AsModal.vue';
    import AsHeadline from '@/components/Ui/AsHeadline.vue';
    import { settingsHelper } from '@/store/modules/settings';
    const settingsHelpers = settingsHelper.mapGetters(['privacyPolicy']);

    export default Vue.extend({
        name: 'PrivacyPolicy',
        components: {
            AsModal,
            AsHeadline,
        },
        data(): { component: any } {
            return {
                component: null,
            };
        },
        computed: {
            ...settingsHelpers,
            loader() {
                // console.log('loading', this.termsConditions)
                return () => import(`../PrivacyPolicy/${this.privacyPolicy}.vue`);
            },
        },
        methods: {
            loadComponent(name: string) {
                return this.loader()
                    .then(() => {
                        this.component = () => this.loader();
                    })
                    .catch(() => {
                        // console.log('failed loading', this.termsConditions);
                        this.component = () => import('../PrivacyPolicy/StandardPrivacyPolicyOB.vue');
                    });
            },
        },
        watch: {
            termsConditions: {
                handler: 'loadComponent' as any,
                immediate: true,
            },
        },
    });
